import React, { useContext, useEffect, useState } from 'react';
import { AuthContext, Role } from '../context/AuthProvider';
import { axiosWrapper } from '../hooks/axios';
import { useGetWithRefetch } from '../hooks/useFetchEndPoint';
import DemoAskModal from './DemoAskModal';
import PollModal from './PollModal';
import Poll from './PollModal/Poll';
import SurveyModal from './SurveyModal';
import { Survey } from './SurveyModal/types';

const ModalContainer: React.FC = () => {
  const user = useContext(AuthContext);
  const [isPollOpen, setIsPollOpen] = useState(false);
  const [hasAskedDemoInfo, setHasAskedDemoInfo] = useState<boolean>(false);
  const [demoAskModalOpened, setDemoAskModalOpened] = useState<boolean>(false);
  const [isSurveyOpen, setIsSurveyOpen] = useState(false);
  const [currentSurvey, setCurrentSurvey] = useState<Survey | null>(null);

  const [pollResponse] = useGetWithRefetch<null | Poll[]>(
    '/api/v1/records/poll/',
  );

  const [surveysResponse, { refetch: refetchSurveys }] = useGetWithRefetch<Survey[]>(
    user && user.is_authenticated ? '/api/v1/surveys/surveys/' : '',
    { running: !!(user && user.is_authenticated) }
  );

  const poll =
    Array.isArray(pollResponse) && pollResponse.length ? pollResponse[0] : null;

  const availableSurveys = Array.isArray(surveysResponse) ? surveysResponse : [];

  useEffect(() => {
    if (!user || !user.is_authenticated) {
      return;
    }
    if (user.roles?.includes(Role.staff)) {
      return;
    }
    if (poll) {
      setIsPollOpen(true);
    }
  }, [user, poll]);

  // Check for available surveys
  useEffect(() => {
    if (!user || !user.is_authenticated) {
      return;
    }

    // Find the first available survey for the user
    const availableSurvey = availableSurveys.find(survey => survey.is_available);

    if (availableSurvey) {
      // Only update if it's a different survey to avoid resetting in-progress survey
      setCurrentSurvey(prev => (prev?.id === availableSurvey.id ? prev : availableSurvey));
      setIsSurveyOpen(true);
    }

  }, [user, availableSurveys]);

  useEffect(() => {
    if (user) {
      if (
        user.demos_to_ask &&
        user.demos_to_ask.length > 0 &&
        !hasAskedDemoInfo
      ) {
        const URL = '/api/v1/records/demo/asked/';
        axiosWrapper<any>(URL, 'patch', {})
          .then((res) => {
            if (res.data.ok) {
              setHasAskedDemoInfo(true);
              setDemoAskModalOpened(true);
            } else {
              alert(res.data.error);
            }
          })
          .catch((err) => console.error(err));
      }
    }
  }, [hasAskedDemoInfo, user]);

  if (poll && isPollOpen) {
    return <PollModal poll={poll} setIsOpen={setIsPollOpen} />;
  }

  if (currentSurvey && isSurveyOpen) {
    return (
      <SurveyModal
        survey={currentSurvey}
        isOpen={isSurveyOpen}
        onClose={() => setIsSurveyOpen(false)}
        onSuccess={() => {
          console.log('Survey completed successfully');
          setIsSurveyOpen(false);
        }}
      />
    );
  }

  if (!demoAskModalOpened) {
    return null;
  }

  return <DemoAskModal setIsOpen={setDemoAskModalOpened} />;
};

export default ModalContainer;
